import React from "react";
import { Pressable } from "react-native";
import { Text } from "../Text";
import { useDeleteButtonStyles } from "./styles";

interface DeleteButtonProps {
  label: string;
  onPress: () => void;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ label, onPress }) => {
  const styles = useDeleteButtonStyles();

  return (
    <Pressable
      testID="keypadKey-delete"
      accessibilityRole="button"
      accessibilityLabel={label}
      onPress={onPress}
      style={styles.button}
    >
      <Text style={styles.icon}>⌫</Text>
    </Pressable>
  );
};

export default DeleteButton;
